// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
// locales
// components
import Label from 'src/components/label';
import { useAuthContext } from 'src/auth/hooks';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------
function getPlane(isVIP: number | undefined) {
  switch (isVIP) {
    case 1:
      return 'Starter';
    case 2:
      return 'Premium';
    default:
      return 'Free';
  }
}
export default function NavUpgrade() {

  const { user } = useAuthContext();
  const { t } = useLocales();
  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Box sx={{ position: 'relative' }}>
          <Avatar src={user?.avatar} alt={user?.name} sx={{ width: 48, height: 48 }} />
          <Label
            color="success"
            variant="filled"
            sx={{
              top: -6,
              px: 0.5,
              left: 40,
              height: 20,
              position: 'absolute',
              borderBottomLeftRadius: 2,
            }}
          >
            {getPlane(user?.isVIP)}
          </Label>
        </Box>

        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
          <Typography variant="subtitle2" noWrap sx={{ color: '#a9a9a9' }}>
            {user?.name}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            {user?.email}
          </Typography>
        </Stack>

        <Button variant="contained" href={paths.lbanka.upgrade} target="_blank" rel="noopener">
          {t('common.button.upgrade')}
        </Button>
      </Stack>
    </Stack>
  );
}
